import Cookies from "js-cookie";

// Simple functions for sending and retrieving the hubspot code

export function getHubspotCodeCookie(): string|undefined {
  return Cookies.get('code');
}
